import Container from '@/components/Container';
import Link from '@/components/Link';
import HeaderSub from '@/view/HeaderSub';
import Partner from '@/domain/Partners/PartnerListing';
import client from '@/api/client';
import { partnerListingQuery } from '@/api/queries';

export async function getStaticProps() {
  const { data } = await client().query({ query: partnerListingQuery });

  return {
    props: {
      partners: data?.partners?.nodes || [],
    },
  };
}

export default function Partners({ partners }) {
  return (
    <div className="bg-white">
      <HeaderSub
        pageTitle={
          <Link className="text-green-500" href="/socios">
            Nuestros socios y colaboradores
          </Link>
        }
        menu={[
          {
            title: 'Listado de socios',
            url: '/socios',
          },
          {
            title: 'Únete al programa',
            url: '/programa-de-socios',
            useArrow: true,
          },
        ]}
      />
      <div className="pt-10 lg:pt-16">
        <Container>
          <div className="grid grid-cols-1 lg:grid-cols-12">
            <div className="text-center lg:col-span-8 lg:col-start-3">
              <h1 className="text-4xl font-bold tracking-tight lg:text-5xl">
                Alianzas duraderas para liderar la&nbsp;
                <div className="text-green-500">transformación ágil</div>
              </h1>
            </div>
          </div>
        </Container>
      </div>
      <div className="z-100 relative">
        <div className="bg-gradient-to-tl from-gray-100 to-white py-10 lg:py-20">
          <Container className="space-y-10 lg:space-y-12">
            <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
              {partners.map(({ id, ...partner }) => (
                <div key={`partner-${id}`} className="flex lg:col-span-6">
                  <Partner key={id} {...partner} />
                </div>
              ))}
            </div>
          </Container>
        </div>
        <div className="bg-green-500 bg-gradient-to-tl from-green-500 to-green-400 py-10 lg:py-20">
          <Container>
            <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-20">
              <Link
                href="/entrenadores"
                className="relative flex transform flex-col space-x-8 overflow-hidden rounded-xl bg-white p-8 pl-28 shadow-lg transition duration-500 ease-in-out hover:shadow-2xl md:flex-row md:items-center lg:col-span-6 lg:rounded-2xl"
              >
                <div className="absolute left-0 top-0 bottom-0 flex items-center">
                  <svg
                    className="relative z-10 -ml-2 h-40 w-40"
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                  >
                    <path
                      className="fill-current text-green-200"
                      d="M8,41l5.818-10.889L18.182,28.3l2.909-5.445h5.818L29.818,28.3l4.364,1.815L40,41H8Z"
                    />
                    <path
                      className="fill-current text-green-500"
                      d="M32,17l-1,3H30l-1,3-4,3H23l-4-3-1-3H17l-1-3h2l-1-6,7-4,7,4-1,6h2Z"
                    />
                  </svg>
                  <div className="absolute left-0 top-0 bottom-0 z-0 w-28 bg-gradient-to-b from-green-200 to-transparent" />
                </div>
                <div className="flex-1 space-y-4">
                  <h2 className="flex items-center space-x-3">
                    <div className="text-xl font-semibold lg:text-2xl">
                      Encuentra un entrenador
                    </div>
                  </h2>
                  <h3 className="text-base font-normal text-gray-500 lg:text-lg">
                    Certificado para enseñar y acompañar a tu equipo en la
                    adopción de la cultura ágil.
                  </h3>
                  <div
                    className="inline-flex items-center space-x-1 text-lg font-semibold"
                    role="button"
                  >
                    <span className="text-green-500">
                      Nuestros entrenadores
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-gray-500"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              </Link>
              <Link
                href="/programa-de-socios"
                className="relative flex transform flex-col space-x-8 overflow-hidden rounded-xl bg-white p-8 pl-28 shadow-lg transition duration-500 ease-in-out hover:shadow-2xl md:flex-row md:items-center lg:col-span-6 lg:rounded-2xl"
              >
                <div className="absolute left-0 top-0 bottom-0 flex items-center">
                  <svg className="relative z-10 h-32 w-32" viewBox="0 0 48 48">
                    <path
                      className="fill-current text-green-200"
                      d="M29.624,43.785L25.381,32.472l7.778-7.778,2.075,8.735ZM4.168,18.329l10.357-5.611,8.735,2.075-7.778,7.778ZM5.624,34.991c1.92-4.929,5.24-2.274,5.24-2.274l2.222,2.217,2.2,2.193s2.627,3.28-2.295,5.213a12.725,12.725,0,0,1-4.578.376c-0.815-.076-3.537,1.6-4.347,1.222-0.39-.814,1.288-3.537,1.207-4.355A12.681,12.681,0,0,1,5.624,34.991Z"
                    />
                    <path
                      className="fill-current text-green-500"
                      d="M10.7,24.537C29.323,6.122,43.983,3.986,43.983,3.986S41.823,18.484,23.2,36.9c0,0-4.841,5.327-11.38-1.14A8.244,8.244,0,0,1,10.7,24.537Z"
                    />
                    <path
                      className="fill-current text-green-200"
                      d="M27.646,20.336a4.454,4.454,0,1,1-6.346-.058A4.512,4.512,0,0,1,27.646,20.336Z"
                    />
                  </svg>
                  <div className="absolute left-0 top-0 bottom-0 z-0 w-28 bg-gradient-to-b from-green-100 to-white" />
                </div>
                <div className="flex-1 space-y-4">
                  <h2 className="flex items-center space-x-3">
                    <div className="text-xl font-semibold lg:text-2xl">
                      Únete al programa de socios
                    </div>
                  </h2>
                  <h3 className="text-base font-normal text-gray-500 lg:text-lg">
                    Para obtener juntos un mayor impacto en la adopción de la
                    cultura ágil.
                  </h3>
                  <div
                    className="inline-flex items-center space-x-1 text-lg font-semibold"
                    role="button"
                  >
                    <span className="text-green-500">Quiero conocer más</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-gray-500"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              </Link>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
}
